module.exports = __webpack_public_path__ + "img/blog-14-2.01fc9b1a.webp";